import { Component, OnInit } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CustomerVenueStatisticItem } from "src/app/shared/models/CustomerVenueStatistic.item";

@Component({
	selector: "app-customer-statistic-dashboard",
	templateUrl: "./customer-statistic-dashboard.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class CustomerStatisticDashboardComponent implements OnInit {
	customerVenueStatistic: CustomerVenueStatisticItem[];
	customerVenueStatisticSelected: CustomerVenueStatisticItem[];

	moment: any = moment;

	viewMode: number = 1;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService) {}

	ngOnInit(): void {}

	async init() {
		this.load();
	}

	async load() {
		await this.statisticGet(this.venueService.subscriptionVenue.value.key);
	}

	async statisticGet(venueKey: number) {
		const resp = await this.focuslink.customerStatistic(venueKey);
		this.customerVenueStatistic = resp.map((i) => new CustomerVenueStatisticItem(i));
		if (this.customerVenueStatistic.length > 0) {
			this.selectSortStatistic(1);
		}
	}

	selectSortStatistic(val: number) {
		this.viewMode = val;
		this.customerVenueStatisticSelected = this.customerVenueStatistic.filter((i) => i.pk === `${this.venueService.subscriptionVenue.value.key}_${val}`);
		this.customerVenueStatisticSelected.sort((a, b) => +b.statisticValue - +a.statisticValue);
		this.customerVenueStatisticSelected.length = this.customerVenueStatisticSelected.length > 5 ? 5 : this.customerVenueStatisticSelected.length;
	}
}
